const 公司劣势 = {
  content: '',
  keywords: {
    平台小: false,
    固薪低: false,
    资源少: false,
    高层变动: false,
    股东方实力弱: false,
    领导口碑差: false,
    激励机制差: false,
  },
}
const 公司亮点 = {
  content: '',
  keywords: {
    股东实力强: false,
    大平台: false,
    固薪高: false,
    激励机制好: false,
    文化好: false,
    人员整体素质高: false,
    压力小: false,
    稳定: false,
  },
}
const 公司用人偏好 = {
  平台: [],
  业绩: [],
  学历: [],
  语言能力: [],
  职业资格: [],
}
const 项目人选标签 = {
  leadership: [],
  personal: [],
  professional: [],
  mentality: [],
  other: [],
}
const 风格 = {
  content: '',
  keywords: {
    A: false,
    B: false,
    C: false,
    D: false,
    E: false,
    F: false,
  },
}
const 风格对应 = {
  A: 'A-极度市场化',
  B: 'B-较市场化',
  C: 'C-大平台、合理激励',
  D: 'D-偏向国企风格，较保守',
  E: 'E-大国企、保守',
  F: '团队作战，精英模式',
}
const 公司模板 = {
  简称: '',
  排名: '',
  签约: '',
  时间: '',
  行业: '',
  网址: '',
  注册地: '',
  股东方: '',
  办公地: '',
  公司名称: '',
  公司性质: '',
  公司类型: '',
  客户开发: '',
  项目对接: '',
  平台等级: '',
  签约时间: '',
  公司介绍: '',
  特殊要求: '',
  总部所在地: '',
  一句话简介: '',
  户口政策: '',
  奖金递延及补偿机制: '',
  休假制度: '',
  用人偏好备注: '',
  面试安排: '',
  '薪酬/职级/奖金机制': '',
  checkdata: '',
  用人偏好: 公司用人偏好,
  tags: 项目人选标签,
}
const 分数统计 = {
  业绩: 0,
  管理能力: 0,
  专业高度: 0,
  资源: 0,
  口碑: 0,
  情商: 0,
}
const 得分结果 = {
  业绩: 0,
  管理能力: 0,
  专业高度: 0,
  资源: 0,
  口碑: 0,
  平均分: 0,
}
export { 公司劣势, 公司亮点, 公司用人偏好, 项目人选标签, 风格, 风格对应, 公司模板, 分数统计, 得分结果 }
